import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Client for sge_infantil_core's routes/classroom.js (mounted at /api/class).
export async function listClassrooms(year, sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  const params = year ? { year } : {};
  return API.get(`${baseURL}api/class/${id}`, { params });
}

export async function createClassroom(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/class`, { sucursalId, ...payload });
}

export async function updateClassroom(classId, payload) {
  return API.put(`${baseURL}api/class/${classId}`, payload);
}

export async function deleteClassroom(classId) {
  return API.delete(`${baseURL}api/class/${classId}`);
}

export async function allocateTeacher(classId, teachers) {
  return API.put(`${baseURL}api/class/allocate-teacher/${classId}`, { teachers });
}

export async function allocateStudents(classId, students) {
  return API.put(`${baseURL}api/class/allocate-students/${classId}`, { students });
}

export async function getNominalListPdf(classId) {
  return API.get(`${baseURL}api/class/nominal-list/${classId}`);
}
